import React from 'react';

import {Modal} from 'react-bootstrap'
import {Glyphicon} from 'react-bootstrap'
import AddClient from '../client/addclientnew'
import AddItem from '../item/edititemnew'
import AddSupplier from '../supplier/addsuppliernew'
import AddBrand from '../brand/addbrand'
import AddBatch from '../batch/addbatch'
import SectionReceipt from '../invoice/receipt'
import SectionPayment from '../purchase/payment'
import AddTransportlabel from '../transportlabel/addtransportlabel'

export class AdditionalParam extends React.Component {

  constructor() {
    super()
    this.addParam = this.addParam.bind(this)
    this.removeParam =this.removeParam.bind(this)
  }

  addParam(e) {
    e.preventDefault()
    if(this.refs.key.value.length > 0 && this.refs.value.value.length > 0) {
      this.props.addParam(this.refs.key.value, this.refs.value.value)
    }
  }

  removeParam(e, key) {
    e.preventDefault()
    this.props.removeParam(key)
  }

  render() {

    let additional_params = this.props.additional_params
  if(typeof additional_params !== "undefined" && additional_params !== null) {
      additional_params = additional_params.map((param, index)=>{

          return <button className="btn btn-default btn-xs" key={index} onClick={(e)=>{this.removeParam(e, param.key)}}>{param.key }: {param.value} <Glyphicon glyph="remove" /></button>

      })
  }

    let submitButton = <button className="btn btn-info btn-xs pull-right" onClick={this.addParam}>Add Param</button>


    return <div className="form-horizontal well">
    <div className="form-group">
        <div className="col-sm-12">
          {additional_params}
        </div>
    </div>
    <div className="form-group">
        <div className="col-sm-6">
          <input type="text" placeholder="Name" ref="key" className="form-control input-sm" onChange={this.handleInputChange} />
        </div>
        <div className="col-sm-6">
            <input type="text" placeholder="Value" ref="value" className="form-control input-sm" onChange={this.handleInputChange} />
        </div>
    </div>

    <div className="form-group">
        <div className="col-sm-6">

        </div>
        <div className="col-sm-6">
            {submitButton}
        </div>
        <div className="col-xs-12">
        <span className="small ">Contact <a href="https://www.goodsbill.com/documentation/" target="_blank">customer care</a> for any assistance</span>
        </div>
    </div>

    </div>


  }

}

export class TransportlabelModal extends React.Component {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this);
    this.state = {show: this.props.show}
  }

  handleClose() {
    this.setState({ show: false });
    this.props.handleClose()
  }

  render() {
    let show = this.props.show
    const modal = (
        <Modal show={show} bsSize="large" onHide={this.handleClose}>
          <Modal.Body>
            <AddTransportlabel onAddCallback={this.props.onAddCallback} invoice={this.props.invoice} />
          </Modal.Body>
        </Modal>
    )
    return   <span>
        {modal}
    </span>
  }
}


export class PaymentModal extends React.Component {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this);
    this.state = {show: this.props.show}
  }

  handleClose() {
    this.setState({ show: false });
    this.props.handleClose()
  }

  render() {

    let show = this.props.show
    let purchase = this.props.purchase
    const modal = (
        <Modal show={show} bsSize="large" onHide={this.handleClose}>
          <Modal.Body>
            <SectionPayment purchase={purchase} />
          </Modal.Body>
        </Modal>
    )
    return   <span>
        {modal}
    </span>
  }
}

export class ReceiptModal extends React.Component {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this);
    this.state = {show: this.props.show}
  }

  handleClose() {
    this.setState({ show: false });
    this.props.handleClose()
  }

  render() {

    let show = this.props.show
    let invoice = this.props.invoice
    const modal = (
        <Modal show={show} bsSize="large" onHide={this.handleClose}>
          <Modal.Body>
            <SectionReceipt invoice={invoice} />
          </Modal.Body>
        </Modal>
    )
    return   <span>
        {modal}
    </span>
  }
}

export class AddBatchModal extends React.Component {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this);
  }
  handleClose() {
    this.props.handleModalToggle()
  }
  render() {
    let show = this.props.show
    const modal = (
        <Modal show={show} bsSize="large" onHide={this.handleClose}>
          <Modal.Body>
            <AddBatch onAddCallback={this.props.onAddCallback} while_purchasing={true} />
          </Modal.Body>
        </Modal>
    )
    return   <span>
        {modal}
    </span>
  }
}

export class AddBrandModal extends React.Component {


  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this);
  }
  handleClose() {
    this.props.handleModalToggle()
  }


  render() {

    let show = this.props.show
    const modal = (
        <Modal show={show} bsSize="large" onHide={this.handleClose}>
          <Modal.Body>
            <AddBrand onAddCallback={this.props.onAddCallback} />
          </Modal.Body>
        </Modal>
    )
    return   <span>
        {modal}
    </span>
  }
}

export class AddSupplierModal extends React.Component {
  constructor(props) {
    super(props)

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handler = this.handler.bind(this)
    this.state = {show: true}
  }
  handler(supplier) {

    this.setState({ show: false });
    this.props.onAddCallback(supplier)
  }
  handleClose() {

    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {

    let show = this.state.show
    const modal = (
        <Modal show={show} bsSize="large" onHide={this.handleClose}>
          <Modal.Body>
            <AddSupplier onAddCallback={this.handler} />
          </Modal.Body>
        </Modal>
    )
    return   <span>
        {modal}
    </span>
  }
}




export class AddClientModal extends React.Component {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this);
  }
  handleClose() {
    this.props.handleModalToggle()
  }


  render() {

    let show = this.props.show
    const modal = (
        <Modal show={show} bsSize="large" onHide={this.handleClose}>
          <Modal.Body>
            <AddClient onAddCallback={this.props.onAddCallback} />
          </Modal.Body>
        </Modal>
    )
    return   <span>
        {modal}
    </span>
  }
}


export class AddItemModal extends React.Component {

  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this);
  }
  handleClose() {
    this.props.handleModalToggle()
  }

  render() {

    let show = this.props.show
    const modal = (
        <Modal show={show} bsSize="large" onHide={this.handleClose}>

          <Modal.Body>
            <AddItem onAddCallback={this.props.onAddCallback} />
          </Modal.Body>

        </Modal>
    )
    return   <span>
        {modal}
    </span>
  }

}



// WEBPACK FOOTER //
// ./src/components/modal/modal.js